import { startOfDay, sub } from 'date-fns';
import add from 'date-fns/add';

import { AccessPermissions } from '../../../backend';

export const getMinAccessibleDateForClient = (permissions: Set<AccessPermissions>, nbDaysToRetrieveFlights: number) => {
    if (Array.from(permissions).includes(AccessPermissions.PAST_MANAGEMENT)) {
        return sub(startOfDay(new Date()), { days: nbDaysToRetrieveFlights });
    } else if (Array.from(permissions).includes(AccessPermissions.TACTICAL_MANAGEMENT)) {
        return sub(startOfDay(new Date()), { days: 1 });
    } else {
        return add(startOfDay(new Date()), { days: 1 });
    }
};
export const getMaxAccessibleDateForClient = (permissions: Set<AccessPermissions>, nbDaysToRetrieveFlights: number) => {
    if (Array.from(permissions).includes(AccessPermissions.PRE_TACTICAL_MANAGEMENT)) {
        return add(startOfDay(new Date()), { days: nbDaysToRetrieveFlights });
    } else {
        return startOfDay(new Date());
    }
};
export const getAuthorizedPeriodForClient = (permissions: Set<AccessPermissions>, nbDaysToRetrieveFlights: number) => {
    let result = 0;
    if (Array.from(permissions).includes(AccessPermissions.PAST_MANAGEMENT)) {
        result += nbDaysToRetrieveFlights;
    }

    if (Array.from(permissions).includes(AccessPermissions.TACTICAL_MANAGEMENT)) {
        if (Array.from(permissions).includes(AccessPermissions.PAST_MANAGEMENT)) {
            result += 1;
        } else {
            result += 2; // J-1 and J
        }
    }

    if (Array.from(permissions).includes(AccessPermissions.PRE_TACTICAL_MANAGEMENT)) {
        result += nbDaysToRetrieveFlights;
    }
    return result;
};
